import { Component, Input } from "@angular/core";
import { ResponseError } from "../../../objects/common/responseError";

@Component({
    selector: 'errors-summary',
    templateUrl: './errorsSummary.component.html',
    moduleId: module.id.toString()
})
export class ErrorsSummaryComponent {
    @Input() public errors: Array<ResponseError | string>;

    public getErrors(): Array<string> {
        let result: string[] = [];

        for (let error of this.errors) {
            if (error instanceof ResponseError && error.Value)
                result = result.concat(error.Value);
            else if (typeof error == "string")
                result.push(error);
        }

        return result;
    }
}




// WEBPACK FOOTER //
// ./app/components/common/errorsSummary/errorsSummary.component.ts